<template>
  <div class="flex flex-col h-full">
    <OrdersTableToggle
      :model-value="filter"
      :orders="orders"
      @update:model-value="(value) => emit('update:filter', value)"
    />

    <div class="h-full min-h-0 border-t border-neutral-secondary">
      <OrdersTableTab
        :filter="filter"
        :orders="orders"
        :is-error-loading-orders="isErrorLoadingOrders"
        :expanded-assets="expandedAssets"
        @get-orders="emit('getOrders')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { OrderItem } from '@libs/api-reference';

import OrdersTableTab from './OrdersTableTab.vue';
import OrdersTableToggle from './OrdersTableToggle.vue';

const { t } = useI18n();

type OrdersTablePanelProps = {
  filter: string;
  orders: OrderItem[];
  isErrorLoadingOrders: boolean;
  expandedAssets: boolean;
};

type OrdersTablePanelEmits = {
  (e: 'update:filter', value: string): void;
  (e: 'getOrders'): void;
};

defineProps<OrdersTablePanelProps>();
const emit = defineEmits<OrdersTablePanelEmits>();
</script>
